import { globalProperties } from '@nextories/vue-core-components/src/plugins/i18n';

export default {
  getTextType(text: string = '', isIndividual: boolean, arrhesPercent: number, arrhesAlreadyPaid: boolean, floaAlreadyPaid: boolean) {
    /**
     * Format text path with suffixes:
     * - Individual: if the client is an individual
     * - WithArrhes: if the client has paid arrhes or WithFloa: if the client has paid Floa
     * - AlreadyPaid: if the client has already paid arrhes
     */
    const individualSuffix = isIndividual ? 'Individual' : '';
    if (floaAlreadyPaid) {
      const floaSuffix = floaAlreadyPaid ? 'WithFloaAlreadyPaid' : '';
      return text + individualSuffix + floaSuffix;
    }
    const arrhesSuffix = arrhesPercent > 0 ? 'WithArrhes' : '';
    const arrhesAlreadyPaidSuffix = arrhesAlreadyPaid ? 'AlreadyPaid' : '';
    return text + individualSuffix + arrhesSuffix + arrhesAlreadyPaidSuffix;
  },
  getTextVersion(text: string = '', params: {
    isIndividual?: boolean;
    withoutArrhes?: boolean;
    arrhesPercent?: number;
    arrhesAlreadyPaid?: boolean;
    floaAlreadyPaid?: boolean;
    isMobile?: boolean;
  } = {}): string | null | object | [] {
    /**
     * Resolution order (fallbacks):
     * 1) `<text> + [Individual][WithArrhes][AlreadyPaid][WithFloaAlreadyPaid] + Mobile` (if `isMobile`)
     * 2) `<text> + [Individual][WithArrhes][AlreadyPaid][WithFloaAlreadyPaid]`
     * 3) if `isIndividual && arrhesPercent && !withoutArrhes`, retry with `withoutArrhes: true` (drops `WithArrhes`)
     *    - this retry restarts the resolution from step 1 (mobile/type/base) with the updated params
     * 4) `<text> + Mobile` (if `isMobile`)
     * 5) `<text>`
     */
    const textType = this.getTextType(
      text,
      !!params.isIndividual,
      params.withoutArrhes ? 0 : (params.arrhesPercent || 0),
      params.arrhesAlreadyPaid || false,
      params.floaAlreadyPaid || false,
    );
    const suffixMobile = 'Mobile';
    // For mobile, try version with mobile suffix AND type suffixes
    if (params.isMobile) {
      const textTypeMobileValue = globalProperties.$tOrFallback(`${textType}${suffixMobile}`, null, params);
      if (textTypeMobileValue) {
        return textTypeMobileValue;
      }
    }
    // Verify if text path with type is defined in i18n
    const textTypeValue = globalProperties.$tOrFallback(textType, null, params);
    if (textTypeValue) {
      return textTypeValue;
    }
    // For individual, try version without arrhes and mobile
    if (params.isIndividual && params.arrhesPercent && !params.withoutArrhes) {
      // Retry on the same base key, but without arrhes (keeps mobile logic intact)
      return text && this.getTextVersion(text, { ...params, withoutArrhes: true, arrhesAlreadyPaid: false, floaAlreadyPaid: false, isMobile: params.isMobile });
    }
    // For mobile, try version with mobile suffix
    if (params.isMobile) {
      const mobileText = globalProperties.$tOrFallback(`${text}${suffixMobile}`, null, params);
      if (mobileText) {
        return mobileText;
      }
    }
    // Fallback: return base text path
    return text && globalProperties.$tOrFallback(text, null, params);
  },
};
